// Legal sayfa içerikleri — Gizlilik Politikası & Kullanım Koşulları
// 3 dil: TR / EN / AR
// Yapı: { [lang]: { privacy: {...}, terms: {...} } }
//   her sayfa: { title, lastUpdated, intro, sections: [{ id, heading, paragraphs, list? }] }

export const legalContent = {
  /* ─────────────────────────────────────────── TÜRKÇE ─────────────────────────────────────────── */
  tr: {
    privacy: {
      title: "Gizlilik Politikası",
      subtitle: "Kişisel verilerinizin korunması bizim için önemlidir. KVKK kapsamında haklarınız ve veri işleme süreçlerimiz.",
      lastUpdated: "Son güncelleme: 10 Nisan 2026",
      intro:
        "Hobala E-Ticaret Reklam Ve Aracılık LTD ŞTİ (\"EntegrePanel\", \"biz\", \"şirket\") olarak, EntegrePanel platformunu (entegrepanel.net ve alt etki alanları) ziyaret eden ve kullanan herkesin kişisel verilerinin gizliliğine ve güvenliğine büyük önem veriyoruz. Bu Gizlilik Politikası, 6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) ve ilgili mevzuat çerçevesinde, hangi verileri topladığımızı, neden işlediğimizi ve haklarınızı açıklamaktadır.",
      sections: [
        {
          id: "veri-sorumlusu",
          heading: "1. Veri Sorumlusu",
          paragraphs: [
            "KVKK madde 3 anlamında veri sorumlusu sıfatıyla hareket eden tüzel kişi:",
            "Hobala E-Ticaret Reklam Ve Aracılık Limited Şirketi (UR-GE Yazılım), Mesudiye Mah. Yıldırım Cad. Yokdemir İş Merkezi No:8, Bursa / Türkiye. İletişim: entegre@entegrepanel.net | +90 224 718 54 00",
          ],
        },
        {
          id: "toplanan-veriler",
          heading: "2. Toplanan Kişisel Veriler",
          paragraphs: ["Hizmetlerimizi kullanırken aşağıdaki kişisel verilerinizi işleyebiliriz:"],
          list: [
            "Kimlik Bilgileri: Ad, soyad, ünvan, şirket adı",
            "İletişim Bilgileri: E-posta adresi, telefon numarası, adres",
            "İşlem Bilgileri: Demo talebi, iletişim formu mesajları, paket tercihleri",
            "Teknik Veriler: IP adresi, tarayıcı türü, işletim sistemi, ziyaret edilen sayfalar",
            "Çerez Verileri: Oturum çerezleri, analitik çerezleri, reklam çerezleri (rıza ile)",
            "Pazarlama Verileri: Bülten aboneliği, kampanya tercihleri",
          ],
        },
        {
          id: "isleme-amaclari",
          heading: "3. Kişisel Verilerin İşlenme Amaçları",
          paragraphs: ["Topladığımız verileri aşağıdaki amaçlar için işliyoruz:"],
          list: [
            "Demo, fiyat teklifi ve bilgi taleplerinizi yanıtlamak",
            "Müşteri hizmetleri ve teknik destek sağlamak",
            "Sözleşme yükümlülüklerimizi yerine getirmek",
            "Hizmetlerimizi geliştirmek ve kişiselleştirmek",
            "Yasal yükümlülüklerimizi (vergi, ticaret kanunu, KVKK vb.) yerine getirmek",
            "Kampanya, ürün ve hizmet bildirimleri göndermek (açık rıza ile)",
            "Web sitesi performansını ölçmek ve site güvenliğini sağlamak",
            "Hukuki süreçler ve uyuşmazlıkların çözümü",
          ],
        },
        {
          id: "isleme-sebebi",
          heading: "4. Kişisel Verilerin İşlenme Hukuki Sebepleri",
          paragraphs: [
            "Verilerinizi KVKK madde 5 ve 6 kapsamında aşağıdaki hukuki sebeplere dayanarak işliyoruz: (a) Açık rızanızın bulunması, (b) Bir sözleşmenin kurulması veya ifası, (c) Hukuki yükümlülüğümüzün yerine getirilmesi, (d) İlgili kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla meşru menfaatlerimiz için zorunlu olması.",
          ],
        },
        {
          id: "veri-aktarimi",
          heading: "5. Kişisel Verilerin Aktarılması",
          paragraphs: [
            "Kişisel verileriniz, KVKK madde 8 ve 9'da belirtilen koşullar çerçevesinde aşağıdaki taraflarla paylaşılabilir:",
          ],
          list: [
            "Hizmet aldığımız bulut sunucu ve barındırma sağlayıcıları",
            "E-posta gönderim hizmeti sağlayıcıları (SMTP)",
            "Analitik ve reklamcılık hizmet sağlayıcıları (Google Analytics, Meta Pixel, Microsoft Clarity, PostHog)",
            "Yasal yükümlülük gereği talep eden resmi kurumlar (mahkeme, savcılık, vergi dairesi)",
            "İş ortakları ve iştirakler (sözleşme kapsamında ve gerektiği ölçüde)",
          ],
        },
        {
          id: "saklama-suresi",
          heading: "6. Verilerin Saklama Süresi",
          paragraphs: [
            "Kişisel verilerinizi, işleme amacının gerektirdiği süre kadar veya yasal saklama yükümlülüklerimiz boyunca (örneğin Türk Ticaret Kanunu uyarınca 10 yıl) saklarız. Süre sonunda veriler güvenli şekilde silinir, yok edilir veya anonim hale getirilir.",
          ],
        },
        {
          id: "cerezler",
          heading: "7. Çerez (Cookie) Politikası",
          paragraphs: [
            "Web sitemizde kullanıcı deneyimini iyileştirmek, site trafiğini analiz etmek ve hedefli reklam göstermek için çerezler kullanılır. Çerezleri tarayıcı ayarlarınızdan dilediğiniz zaman yönetebilir veya devre dışı bırakabilirsiniz.",
            "Kullandığımız çerez kategorileri: (1) Zorunlu Çerezler — sitenin temel işlevleri için, (2) Performans Çerezleri — Google Analytics, Microsoft Clarity, (3) Pazarlama Çerezleri — Meta Pixel, Google Ads (4) Tercih Çerezleri — dil seçimi.",
          ],
        },
        {
          id: "haklariniz",
          heading: "8. KVKK Kapsamında Haklarınız",
          paragraphs: [
            "KVKK madde 11 uyarınca veri sahibi olarak aşağıdaki haklara sahipsiniz:",
          ],
          list: [
            "Kişisel verilerinizin işlenip işlenmediğini öğrenme",
            "İşlenmişse buna ilişkin bilgi talep etme",
            "İşlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme",
            "Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme",
            "Eksik veya yanlış işlenmişse düzeltilmesini isteme",
            "Silinmesini veya yok edilmesini isteme",
            "Düzeltme/silme/yok etme işlemlerinin aktarılan üçüncü kişilere bildirilmesini isteme",
            "İşlenen verilerin münhasıran otomatik sistemlerle analiz edilmesi nedeniyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme",
            "KVKK'ya aykırı işleme nedeniyle zarara uğramanız halinde zararın giderilmesini talep etme",
          ],
        },
        {
          id: "basvuru",
          heading: "9. Başvuru ve İletişim",
          paragraphs: [
            "Yukarıdaki haklarınızı kullanmak için entegre@entegrepanel.net adresine kimlik doğrulayıcı bilgilerinizle birlikte başvurabilirsiniz. Başvurunuz en geç 30 gün içinde sonuçlandırılacaktır.",
            "Hobala E-Ticaret Reklam Ve Aracılık LTD ŞTİ — Mesudiye Mah. Yıldırım Cad. Yokdemir İş Merkezi No:8, Bursa | Tel: +90 224 718 54 00 | E-posta: entegre@entegrepanel.net",
          ],
        },
        {
          id: "degisiklikler",
          heading: "10. Politika Değişiklikleri",
          paragraphs: [
            "Bu Gizlilik Politikası, mevzuat değişiklikleri veya hizmetlerimizdeki güncellemeler nedeniyle zaman zaman güncellenebilir. Güncel sürüm her zaman bu sayfada yayınlanır. Önemli değişikliklerde size e-posta veya site üzerinden bildirimde bulunulacaktır.",
          ],
        },
      ],
    },
    terms: {
      title: "Kullanım Koşulları",
      subtitle: "EntegrePanel platformunu kullanırken uyman gereken şartlar, taraf hak ve yükümlülükleri.",
      lastUpdated: "Son güncelleme: 10 Nisan 2026",
      intro:
        "Bu Kullanım Koşulları, EntegrePanel (\"Platform\") web sitesini ve hizmetlerini kullanan tüm kullanıcılar için geçerlidir. Platforma erişerek veya hizmetlerimizden yararlanarak aşağıdaki şartları kabul etmiş sayılırsınız. Lütfen bu metni dikkatle okuyunuz.",
      sections: [
        {
          id: "taraflar",
          heading: "1. Taraflar",
          paragraphs: [
            "İşbu sözleşme, bir tarafta Hobala E-Ticaret Reklam Ve Aracılık Limited Şirketi (\"EntegrePanel\", \"Şirket\") ile diğer tarafta Platform'u kullanan gerçek veya tüzel kişi (\"Kullanıcı\") arasında akdedilmiştir.",
          ],
        },
        {
          id: "hizmet-tanimi",
          heading: "2. Hizmet Tanımı",
          paragraphs: [
            "EntegrePanel, B2B bayi yönetim sistemi olarak; teklif yönetimi, sipariş takibi, bayi portalı, entegre tedarikçi sistemi, ön muhasebe, B2B CRM, çoklu döviz desteği ve raporlama özellikleri sunan bulut tabanlı bir SaaS platformudur. Hizmetin kapsamı ve özellikleri, satın alınan paket türüne göre değişiklik gösterir.",
          ],
        },
        {
          id: "uyelik",
          heading: "3. Üyelik ve Hesap",
          paragraphs: [
            "Platformu kullanmak için kayıt olarak bir hesap oluşturmanız gerekir. Kayıt sırasında verdiğiniz bilgilerin doğru, güncel ve eksiksiz olduğunu kabul edersiniz. Hesap güvenliğinizden (kullanıcı adı, şifre vb.) tamamen siz sorumlusunuz. Hesabınız üzerinden gerçekleştirilen tüm işlemlerden sorumlu tutulursunuz.",
          ],
        },
        {
          id: "kullanici-yukumlulukleri",
          heading: "4. Kullanıcı Yükümlülükleri",
          paragraphs: ["Platformu kullanırken aşağıdaki kurallara uymayı kabul edersiniz:"],
          list: [
            "Yürürlükteki tüm yasalara, yönetmeliklere ve etik kurallara uymak",
            "Üçüncü tarafların fikri mülkiyet haklarını ihlal etmemek",
            "Sahte, yanıltıcı veya zararlı içerik yüklememek",
            "Spam, kötü amaçlı yazılım veya zararlı kod göndermemek",
            "Sistemin güvenlik açıklarını araştırmamak veya istismar etmemek",
            "Diğer kullanıcıların hesaplarına yetkisiz erişim sağlamamak",
            "Hizmetimizi rakip ürün geliştirmek için tersine mühendislik yapmamak",
            "Aboneliğinizi başka bir gerçek/tüzel kişiye devretmemek (yazılı izin olmadan)",
          ],
        },
        {
          id: "fikri-mulkiyet",
          heading: "5. Fikri Mülkiyet Hakları",
          paragraphs: [
            "EntegrePanel platformu, tüm yazılım kodu, tasarım, logo, marka, içerik ve dokümantasyonun tüm fikri mülkiyet hakları Hobala E-Ticaret Reklam Ve Aracılık LTD ŞTİ ve UR-GE Yazılım'a aittir. Kullanıcı, Platformu yalnızca şahsi/şirket içi iş amaçlı kullanma hakkına sahiptir; çoğaltamaz, dağıtamaz, satamaz veya türev eserler oluşturamaz.",
            "Kullanıcının Platforma yüklediği içerikler (ürünler, müşteri verileri vb.) Kullanıcı'ya aittir. EntegrePanel bu içerikleri yalnızca hizmet sunumu amacıyla işler.",
          ],
        },
        {
          id: "odeme",
          heading: "6. Ödeme ve Ücretlendirme",
          paragraphs: [
            "Ücretli paketler için belirlenen ücretler, ilgili paketin özelliklerine göre yıllık bazda tahsil edilir. Ödemeler, online ödeme altyapısı veya banka havalesi yoluyla yapılabilir. Ücretsiz paket, belirtilen limitler dahilinde herhangi bir ücret ödenmeden kullanılabilir.",
            "EntegrePanel, fiyatları önceden bildirimde bulunarak değiştirme hakkını saklı tutar. Mevcut aboneliklerin yenilenmesinde güncel fiyatlar geçerli olur.",
          ],
        },
        {
          id: "iptal",
          heading: "7. İptal ve İade",
          paragraphs: [
            "Kullanıcı, dilediği zaman aboneliğini iptal etme hakkına sahiptir. İptal halinde mevcut abonelik dönemi sonuna kadar hizmet kullanılmaya devam edilir. Ücretsiz deneme süreleri haricinde, ödenen ücretler iade edilmez.",
            "Tüketici sıfatına sahip kullanıcılar için 6502 sayılı Tüketicinin Korunması Hakkında Kanun uyarınca cayma hakları saklıdır.",
          ],
        },
        {
          id: "sorumluluk",
          heading: "8. Sorumluluk Reddi ve Sınırlamalar",
          paragraphs: [
            "Platform \"olduğu gibi\" sunulmaktadır. EntegrePanel, makul ölçüde Platform'un kesintisiz ve hatasız çalışması için çaba gösterse de, mücbir sebepler, internet altyapısı sorunları, üçüncü taraf hizmet kesintileri veya bakım çalışmaları nedeniyle hizmet aksamaları yaşanabilir.",
            "EntegrePanel, dolaylı, arızi, özel veya cezai zararlardan (kar kaybı, veri kaybı, iş kesintisi vb.) sorumlu tutulamaz. Toplam yükümlülüğümüz, son 12 ayda ödediğiniz ücretle sınırlıdır.",
          ],
        },
        {
          id: "fesih",
          heading: "9. Sözleşmenin Feshi",
          paragraphs: [
            "EntegrePanel, kullanıcının bu Kullanım Koşulları'na aykırı davranması, sahte bilgi vermesi, sistemi kötüye kullanması veya yasa dışı faaliyetlerde bulunması durumunda hesabı askıya alma veya sonlandırma hakkını saklı tutar.",
          ],
        },
        {
          id: "degisiklikler",
          heading: "10. Koşullarda Değişiklik",
          paragraphs: [
            "EntegrePanel, bu Kullanım Koşulları'nı zaman zaman güncelleyebilir. Önemli değişiklikler kullanıcılara e-posta veya Platform üzerinden bildirilir. Değişiklikler yayınlandıktan sonra Platform'u kullanmaya devam etmeniz, güncellenmiş koşulları kabul ettiğiniz anlamına gelir.",
          ],
        },
        {
          id: "hukuk",
          heading: "11. Uygulanacak Hukuk ve Yetki",
          paragraphs: [
            "Bu Kullanım Koşulları Türk Hukuku'na tabidir. İşbu sözleşmeden doğabilecek uyuşmazlıkların çözümünde Bursa Mahkemeleri ve İcra Daireleri yetkilidir.",
          ],
        },
        {
          id: "iletisim",
          heading: "12. İletişim",
          paragraphs: [
            "Kullanım Koşulları hakkında soru veya görüşleriniz için bizimle iletişime geçebilirsiniz: Hobala E-Ticaret Reklam Ve Aracılık LTD ŞTİ — Mesudiye Mah. Yıldırım Cad. Yokdemir İş Merkezi No:8, Bursa | Tel: +90 224 718 54 00 | E-posta: entegre@entegrepanel.net",
          ],
        },
      ],
    },
  },

  /* ─────────────────────────────────────────── ENGLISH ─────────────────────────────────────────── */
  en: {
    privacy: {
      title: "Privacy Policy",
      subtitle: "Protecting your personal data is important to us. Your rights and our data processing under applicable law.",
      lastUpdated: "Last updated: April 10, 2026",
      intro:
        "Hobala E-Ticaret Reklam Ve Aracılık LTD ŞTİ (\"EntegrePanel\", \"we\", \"the company\") values the privacy and security of personal data of every visitor and user of the EntegrePanel platform (entegrepanel.net and subdomains). This Privacy Policy explains, under the framework of the Turkish Personal Data Protection Law No. 6698 (KVKK) and applicable regulations, what data we collect, why we process it, and your rights.",
      sections: [
        {
          id: "data-controller",
          heading: "1. Data Controller",
          paragraphs: [
            "The legal entity acting as the data controller within the meaning of KVKK Article 3:",
            "Hobala E-Ticaret Reklam Ve Aracılık Limited Şirketi (UR-GE Yazılım), Mesudiye Mah. Yıldırım Cad. Yokdemir İş Merkezi No:8, Bursa / Türkiye. Contact: entegre@entegrepanel.net | +90 224 718 54 00",
          ],
        },
        {
          id: "collected-data",
          heading: "2. Personal Data Collected",
          paragraphs: ["When using our services, we may process the following personal data:"],
          list: [
            "Identity Information: First name, last name, title, company name",
            "Contact Information: Email address, phone number, address",
            "Transaction Information: Demo requests, contact form messages, package preferences",
            "Technical Data: IP address, browser type, operating system, pages visited",
            "Cookie Data: Session cookies, analytics cookies, advertising cookies (with consent)",
            "Marketing Data: Newsletter subscription, campaign preferences",
          ],
        },
        {
          id: "purposes",
          heading: "3. Purposes of Processing",
          paragraphs: ["We process the data we collect for the following purposes:"],
          list: [
            "Responding to your demo, quote, and information requests",
            "Providing customer service and technical support",
            "Fulfilling our contractual obligations",
            "Improving and personalizing our services",
            "Complying with legal obligations (tax, commerce law, data protection, etc.)",
            "Sending campaign, product, and service notifications (with explicit consent)",
            "Measuring website performance and ensuring site security",
            "Resolving legal processes and disputes",
          ],
        },
        {
          id: "legal-basis",
          heading: "4. Legal Basis for Processing",
          paragraphs: [
            "We process your data based on the legal grounds set out in Articles 5 and 6 of the KVKK: (a) Your explicit consent, (b) Necessity for the formation or performance of a contract, (c) Compliance with our legal obligations, (d) Necessity for our legitimate interests, provided that the fundamental rights and freedoms of the data subject are not harmed.",
          ],
        },
        {
          id: "data-sharing",
          heading: "5. Data Sharing",
          paragraphs: [
            "Your personal data may be shared with the following parties under conditions specified in KVKK Articles 8 and 9:",
          ],
          list: [
            "Cloud server and hosting service providers",
            "Email delivery service providers (SMTP)",
            "Analytics and advertising service providers (Google Analytics, Meta Pixel, Microsoft Clarity, PostHog)",
            "Authorities required by legal obligation (courts, prosecution, tax office)",
            "Business partners and affiliates (within the scope of contracts and to the extent necessary)",
          ],
        },
        {
          id: "retention",
          heading: "6. Data Retention Period",
          paragraphs: [
            "We retain your personal data for as long as necessary for the processing purpose or as required by our legal retention obligations (e.g. 10 years under the Turkish Commercial Code). At the end of this period, the data is securely deleted, destroyed, or anonymized.",
          ],
        },
        {
          id: "cookies",
          heading: "7. Cookie Policy",
          paragraphs: [
            "We use cookies on our website to improve user experience, analyze site traffic, and display targeted advertising. You can manage or disable cookies through your browser settings at any time.",
            "Cookie categories we use: (1) Essential Cookies — for core site functions, (2) Performance Cookies — Google Analytics, Microsoft Clarity, (3) Marketing Cookies — Meta Pixel, Google Ads, (4) Preference Cookies — language selection.",
          ],
        },
        {
          id: "your-rights",
          heading: "8. Your Rights Under KVKK",
          paragraphs: [
            "Pursuant to Article 11 of the KVKK, you have the following rights as a data subject:",
          ],
          list: [
            "To learn whether your personal data is being processed",
            "To request information if your data is processed",
            "To learn the purpose of processing and whether it is used in accordance with that purpose",
            "To know the third parties to whom data is transferred domestically or abroad",
            "To request correction if data is incomplete or incorrect",
            "To request deletion or destruction",
            "To request that correction/deletion/destruction be communicated to third parties",
            "To object to the emergence of an adverse result by analyzing the processed data exclusively through automated systems",
            "To claim compensation if you suffer damages due to unlawful processing",
          ],
        },
        {
          id: "contact",
          heading: "9. Application and Contact",
          paragraphs: [
            "To exercise your above rights, you can apply to entegre@entegrepanel.net with your identity verification information. Your application will be finalized within 30 days at the latest.",
            "Hobala E-Ticaret Reklam Ve Aracılık LTD ŞTİ — Mesudiye Mah. Yıldırım Cad. Yokdemir İş Merkezi No:8, Bursa | Phone: +90 224 718 54 00 | Email: entegre@entegrepanel.net",
          ],
        },
        {
          id: "changes",
          heading: "10. Policy Changes",
          paragraphs: [
            "This Privacy Policy may be updated from time to time due to legal changes or updates to our services. The latest version is always published on this page. You will be notified of significant changes via email or through the website.",
          ],
        },
      ],
    },
    terms: {
      title: "Terms of Service",
      subtitle: "The terms, rights, and obligations governing your use of the EntegrePanel platform.",
      lastUpdated: "Last updated: April 10, 2026",
      intro:
        "These Terms of Service apply to all users of the EntegrePanel (\"Platform\") website and services. By accessing the Platform or using our services, you agree to be bound by the following terms. Please read this document carefully.",
      sections: [
        {
          id: "parties",
          heading: "1. Parties",
          paragraphs: [
            "This agreement is concluded between Hobala E-Ticaret Reklam Ve Aracılık Limited Şirketi (\"EntegrePanel\", \"Company\") on one side, and the natural or legal person using the Platform (\"User\") on the other side.",
          ],
        },
        {
          id: "service",
          heading: "2. Service Description",
          paragraphs: [
            "EntegrePanel is a cloud-based SaaS platform offering quote management, order tracking, dealer portal, integrated supplier system, pre-accounting, B2B CRM, multi-currency support, and reporting features as a B2B dealer management system. The scope and features of the service vary depending on the package purchased.",
          ],
        },
        {
          id: "account",
          heading: "3. Account and Registration",
          paragraphs: [
            "To use the Platform, you must create an account by registering. You agree that the information you provide during registration is accurate, current, and complete. You are entirely responsible for the security of your account (username, password, etc.) and held liable for all transactions performed through your account.",
          ],
        },
        {
          id: "user-obligations",
          heading: "4. User Obligations",
          paragraphs: ["When using the Platform, you agree to comply with the following rules:"],
          list: [
            "Comply with all applicable laws, regulations, and ethical rules",
            "Not infringe on third-party intellectual property rights",
            "Not upload false, misleading, or harmful content",
            "Not send spam, malware, or harmful code",
            "Not investigate or exploit system security vulnerabilities",
            "Not gain unauthorized access to other users' accounts",
            "Not reverse-engineer the service to develop competing products",
            "Not transfer your subscription to another natural/legal person (without written permission)",
          ],
        },
        {
          id: "intellectual-property",
          heading: "5. Intellectual Property Rights",
          paragraphs: [
            "All intellectual property rights of the EntegrePanel platform, including software code, design, logo, brand, content, and documentation, belong to Hobala E-Ticaret Reklam Ve Aracılık LTD ŞTİ and UR-GE Yazılım. The User has the right to use the Platform only for personal/internal business purposes; cannot reproduce, distribute, sell, or create derivative works.",
            "Content uploaded by the User to the Platform (products, customer data, etc.) belongs to the User. EntegrePanel processes this content only for the purpose of service delivery.",
          ],
        },
        {
          id: "payment",
          heading: "6. Payment and Pricing",
          paragraphs: [
            "Fees set for paid packages are charged annually based on the features of the relevant package. Payments can be made via online payment infrastructure or bank transfer. The Free package can be used within the specified limits without paying any fee.",
            "EntegrePanel reserves the right to change prices with prior notice. Current prices apply when renewing existing subscriptions.",
          ],
        },
        {
          id: "cancellation",
          heading: "7. Cancellation and Refund",
          paragraphs: [
            "The User has the right to cancel their subscription at any time. In case of cancellation, the service continues to be used until the end of the current subscription period. Except for free trial periods, paid fees are non-refundable.",
            "For users with consumer status, withdrawal rights are reserved under the Consumer Protection Law No. 6502.",
          ],
        },
        {
          id: "disclaimer",
          heading: "8. Disclaimer and Limitation of Liability",
          paragraphs: [
            "The Platform is provided \"as is\". Although EntegrePanel makes reasonable efforts to ensure that the Platform operates uninterrupted and error-free, service interruptions may occur due to force majeure, internet infrastructure problems, third-party service interruptions, or maintenance.",
            "EntegrePanel cannot be held liable for indirect, incidental, special, or punitive damages (loss of profit, data loss, business interruption, etc.). Our total liability is limited to the fees you paid in the last 12 months.",
          ],
        },
        {
          id: "termination",
          heading: "9. Termination",
          paragraphs: [
            "EntegrePanel reserves the right to suspend or terminate the account if the user violates these Terms of Service, provides false information, abuses the system, or engages in illegal activities.",
          ],
        },
        {
          id: "changes",
          heading: "10. Changes to Terms",
          paragraphs: [
            "EntegrePanel may update these Terms of Service from time to time. Significant changes are notified to users via email or through the Platform. Continuing to use the Platform after changes are published means you accept the updated terms.",
          ],
        },
        {
          id: "governing-law",
          heading: "11. Governing Law and Jurisdiction",
          paragraphs: [
            "These Terms of Service are governed by Turkish Law. Bursa Courts and Enforcement Offices have jurisdiction in resolving disputes that may arise from this agreement.",
          ],
        },
        {
          id: "contact",
          heading: "12. Contact",
          paragraphs: [
            "For questions or comments about the Terms of Service, you can contact us: Hobala E-Ticaret Reklam Ve Aracılık LTD ŞTİ — Mesudiye Mah. Yıldırım Cad. Yokdemir İş Merkezi No:8, Bursa | Phone: +90 224 718 54 00 | Email: entegre@entegrepanel.net",
          ],
        },
      ],
    },
  },

  /* ─────────────────────────────────────────── ARABIC ─────────────────────────────────────────── */
  ar: {
    privacy: {
      title: "سياسة الخصوصية",
      subtitle: "حماية بياناتك الشخصية أمر مهم بالنسبة لنا. حقوقك ومعالجة بياناتك بموجب القوانين المعمول بها.",
      lastUpdated: "آخر تحديث: 10 أبريل 2026",
      intro:
        "تولي شركة Hobala E-Ticaret Reklam Ve Aracılık LTD ŞTİ (\"EntegrePanel\"، \"نحن\"، \"الشركة\") أهمية كبيرة لخصوصية وأمان البيانات الشخصية لكل زائر ومستخدم لمنصة EntegrePanel (entegrepanel.net والنطاقات الفرعية). توضح سياسة الخصوصية هذه، في إطار قانون حماية البيانات الشخصية التركي رقم 6698 (KVKK) واللوائح المعمول بها، البيانات التي نجمعها وأسباب معالجتها وحقوقك.",
      sections: [
        {
          id: "data-controller",
          heading: "1. مراقب البيانات",
          paragraphs: [
            "الكيان القانوني الذي يعمل كمراقب بيانات بموجب المادة 3 من KVKK:",
            "Hobala E-Ticaret Reklam Ve Aracılık Limited Şirketi (UR-GE Yazılım)، Mesudiye Mah. Yıldırım Cad. Yokdemir İş Merkezi No:8، بورصة / تركيا. للتواصل: entegre@entegrepanel.net | +90 224 718 54 00",
          ],
        },
        {
          id: "collected-data",
          heading: "2. البيانات الشخصية التي يتم جمعها",
          paragraphs: ["عند استخدام خدماتنا، قد نقوم بمعالجة البيانات الشخصية التالية:"],
          list: [
            "معلومات الهوية: الاسم الأول، اللقب، المسمى الوظيفي، اسم الشركة",
            "معلومات الاتصال: البريد الإلكتروني، رقم الهاتف، العنوان",
            "معلومات المعاملات: طلبات العرض التجريبي، رسائل نموذج الاتصال، تفضيلات الباقة",
            "البيانات التقنية: عنوان IP، نوع المتصفح، نظام التشغيل، الصفحات التي تمت زيارتها",
            "بيانات ملفات تعريف الارتباط: ملفات تعريف الارتباط للجلسة، ملفات تعريف الارتباط التحليلية، ملفات تعريف الارتباط الإعلانية (بموافقتك)",
            "بيانات التسويق: الاشتراك في النشرة الإخبارية، تفضيلات الحملات",
          ],
        },
        {
          id: "purposes",
          heading: "3. أغراض المعالجة",
          paragraphs: ["نقوم بمعالجة البيانات التي نجمعها للأغراض التالية:"],
          list: [
            "الاستجابة لطلبات العرض التجريبي والعروض والمعلومات",
            "تقديم خدمة العملاء والدعم الفني",
            "الوفاء بالتزاماتنا التعاقدية",
            "تحسين خدماتنا وتخصيصها",
            "الامتثال للالتزامات القانونية (الضرائب، قانون التجارة، حماية البيانات، إلخ)",
            "إرسال إشعارات الحملات والمنتجات والخدمات (بموافقة صريحة)",
            "قياس أداء الموقع وضمان أمانه",
            "حل العمليات القانونية والنزاعات",
          ],
        },
        {
          id: "legal-basis",
          heading: "4. الأساس القانوني للمعالجة",
          paragraphs: [
            "نقوم بمعالجة بياناتك بناءً على الأسس القانونية المنصوص عليها في المادتين 5 و 6 من KVKK: (أ) موافقتك الصريحة، (ب) ضرورة لتكوين أو تنفيذ عقد، (ج) الامتثال لالتزاماتنا القانونية، (د) ضرورة لمصالحنا المشروعة، شريطة عدم الإضرار بالحقوق والحريات الأساسية لصاحب البيانات.",
          ],
        },
        {
          id: "data-sharing",
          heading: "5. مشاركة البيانات",
          paragraphs: [
            "قد تتم مشاركة بياناتك الشخصية مع الأطراف التالية بموجب الشروط المحددة في المادتين 8 و 9 من KVKK:",
          ],
          list: [
            "مقدمي خدمات الخوادم السحابية والاستضافة",
            "مقدمي خدمات إرسال البريد الإلكتروني (SMTP)",
            "مقدمي خدمات التحليلات والإعلانات (Google Analytics، Meta Pixel، Microsoft Clarity، PostHog)",
            "السلطات المطلوبة بموجب الالتزام القانوني (المحاكم، النيابة، مكتب الضرائب)",
            "الشركاء التجاريون والشركات التابعة (في نطاق العقود وبالقدر اللازم)",
          ],
        },
        {
          id: "retention",
          heading: "6. فترة الاحتفاظ بالبيانات",
          paragraphs: [
            "نحتفظ ببياناتك الشخصية لأطول فترة ضرورية لأغراض المعالجة أو حسبما تتطلبه التزاماتنا القانونية للاحتفاظ (مثل 10 سنوات بموجب القانون التجاري التركي). في نهاية هذه الفترة، يتم حذف البيانات أو تدميرها أو إخفاء هويتها بشكل آمن.",
          ],
        },
        {
          id: "cookies",
          heading: "7. سياسة ملفات تعريف الارتباط",
          paragraphs: [
            "نستخدم ملفات تعريف الارتباط على موقعنا لتحسين تجربة المستخدم وتحليل حركة المرور وعرض الإعلانات المستهدفة. يمكنك إدارة ملفات تعريف الارتباط أو تعطيلها من إعدادات المتصفح في أي وقت.",
            "فئات ملفات تعريف الارتباط التي نستخدمها: (1) ملفات تعريف الارتباط الأساسية - لوظائف الموقع الأساسية، (2) ملفات تعريف الارتباط للأداء - Google Analytics، Microsoft Clarity، (3) ملفات تعريف الارتباط للتسويق - Meta Pixel، Google Ads، (4) ملفات تعريف الارتباط للتفضيلات - اختيار اللغة.",
          ],
        },
        {
          id: "your-rights",
          heading: "8. حقوقك بموجب KVKK",
          paragraphs: ["وفقًا للمادة 11 من KVKK، لديك الحقوق التالية كصاحب بيانات:"],
          list: [
            "معرفة ما إذا كانت بياناتك الشخصية تتم معالجتها",
            "طلب معلومات إذا تمت معالجة بياناتك",
            "معرفة الغرض من المعالجة وما إذا كانت تستخدم وفقًا لذلك الغرض",
            "معرفة الأطراف الثالثة التي يتم نقل البيانات إليها محليًا أو خارجيًا",
            "طلب التصحيح إذا كانت البيانات غير مكتملة أو غير صحيحة",
            "طلب الحذف أو التدمير",
            "طلب إبلاغ الأطراف الثالثة بعمليات التصحيح/الحذف/التدمير",
            "الاعتراض على ظهور نتيجة سلبية بسبب التحليل الآلي للبيانات",
            "المطالبة بالتعويض إذا تعرضت لأضرار بسبب المعالجة غير القانونية",
          ],
        },
        {
          id: "contact",
          heading: "9. التطبيق والاتصال",
          paragraphs: [
            "لممارسة حقوقك المذكورة أعلاه، يمكنك التقدم بطلب إلى entegre@entegrepanel.net مع معلومات التحقق من الهوية. سيتم الانتهاء من طلبك في غضون 30 يومًا كحد أقصى.",
            "Hobala E-Ticaret Reklam Ve Aracılık LTD ŞTİ — Mesudiye Mah. Yıldırım Cad. Yokdemir İş Merkezi No:8، بورصة | الهاتف: +90 224 718 54 00 | البريد الإلكتروني: entegre@entegrepanel.net",
          ],
        },
        {
          id: "changes",
          heading: "10. التغييرات في السياسة",
          paragraphs: [
            "قد يتم تحديث سياسة الخصوصية هذه من وقت لآخر بسبب التغييرات القانونية أو التحديثات في خدماتنا. يتم نشر أحدث إصدار دائمًا على هذه الصفحة. سيتم إعلامك بالتغييرات الهامة عبر البريد الإلكتروني أو من خلال الموقع.",
          ],
        },
      ],
    },
    terms: {
      title: "شروط الخدمة",
      subtitle: "الشروط والحقوق والالتزامات التي تحكم استخدامك لمنصة EntegrePanel.",
      lastUpdated: "آخر تحديث: 10 أبريل 2026",
      intro:
        "تنطبق شروط الخدمة هذه على جميع مستخدمي موقع EntegrePanel (\"المنصة\") والخدمات. من خلال الوصول إلى المنصة أو استخدام خدماتنا، فإنك توافق على الالتزام بالشروط التالية. يرجى قراءة هذه الوثيقة بعناية.",
      sections: [
        {
          id: "parties",
          heading: "1. الأطراف",
          paragraphs: [
            "تم إبرام هذه الاتفاقية بين Hobala E-Ticaret Reklam Ve Aracılık Limited Şirketi (\"EntegrePanel\"، \"الشركة\") من جهة، والشخص الطبيعي أو الاعتباري الذي يستخدم المنصة (\"المستخدم\") من جهة أخرى.",
          ],
        },
        {
          id: "service",
          heading: "2. وصف الخدمة",
          paragraphs: [
            "EntegrePanel هو منصة SaaS قائمة على السحابة تقدم إدارة العروض، تتبع الطلبات، بوابة الوكلاء، نظام الموردين المتكامل، المحاسبة الأولية، CRM للأعمال B2B، دعم العملات المتعددة، وميزات إعداد التقارير كنظام لإدارة الوكلاء B2B. يختلف نطاق وميزات الخدمة حسب نوع الباقة المشتراة.",
          ],
        },
        {
          id: "account",
          heading: "3. الحساب والتسجيل",
          paragraphs: [
            "لاستخدام المنصة، يجب عليك إنشاء حساب من خلال التسجيل. أنت توافق على أن المعلومات التي تقدمها أثناء التسجيل دقيقة وحديثة وكاملة. أنت مسؤول تمامًا عن أمان حسابك (اسم المستخدم وكلمة المرور وما إلى ذلك) وتتحمل مسؤولية جميع المعاملات التي تتم من خلال حسابك.",
          ],
        },
        {
          id: "user-obligations",
          heading: "4. التزامات المستخدم",
          paragraphs: ["عند استخدام المنصة، فإنك توافق على الالتزام بالقواعد التالية:"],
          list: [
            "الامتثال لجميع القوانين واللوائح والقواعد الأخلاقية المعمول بها",
            "عدم انتهاك حقوق الملكية الفكرية للأطراف الثالثة",
            "عدم تحميل محتوى زائف أو مضلل أو ضار",
            "عدم إرسال الرسائل غير المرغوب فيها أو البرامج الضارة أو الأكواد الضارة",
            "عدم التحقيق في الثغرات الأمنية للنظام أو استغلالها",
            "عدم الوصول غير المصرح به إلى حسابات المستخدمين الآخرين",
            "عدم القيام بالهندسة العكسية للخدمة لتطوير منتجات منافسة",
            "عدم نقل اشتراكك إلى شخص طبيعي/اعتباري آخر (دون إذن كتابي)",
          ],
        },
        {
          id: "intellectual-property",
          heading: "5. حقوق الملكية الفكرية",
          paragraphs: [
            "جميع حقوق الملكية الفكرية لمنصة EntegrePanel، بما في ذلك كود البرنامج والتصميم والشعار والعلامة التجارية والمحتوى والوثائق، تخص Hobala E-Ticaret Reklam Ve Aracılık LTD ŞTİ و UR-GE Yazılım. للمستخدم الحق في استخدام المنصة فقط للأغراض التجارية الشخصية/الداخلية؛ لا يمكن استنساخها أو توزيعها أو بيعها أو إنشاء أعمال مشتقة.",
            "المحتوى الذي يقوم المستخدم بتحميله إلى المنصة (المنتجات، بيانات العملاء، وما إلى ذلك) يخص المستخدم. تقوم EntegrePanel بمعالجة هذا المحتوى فقط لغرض تقديم الخدمة.",
          ],
        },
        {
          id: "payment",
          heading: "6. الدفع والتسعير",
          paragraphs: [
            "يتم تحصيل الرسوم المحددة للباقات المدفوعة سنويًا بناءً على ميزات الباقة ذات الصلة. يمكن إجراء المدفوعات عبر البنية التحتية للدفع عبر الإنترنت أو التحويل المصرفي. يمكن استخدام الباقة المجانية ضمن الحدود المحددة دون دفع أي رسوم.",
            "تحتفظ EntegrePanel بالحق في تغيير الأسعار بإشعار مسبق. تطبق الأسعار الحالية عند تجديد الاشتراكات الحالية.",
          ],
        },
        {
          id: "cancellation",
          heading: "7. الإلغاء والاسترداد",
          paragraphs: [
            "للمستخدم الحق في إلغاء اشتراكه في أي وقت. في حالة الإلغاء، تستمر الخدمة في الاستخدام حتى نهاية فترة الاشتراك الحالية. باستثناء فترات التجربة المجانية، الرسوم المدفوعة غير قابلة للاسترداد.",
            "للمستخدمين الذين لديهم وضع المستهلك، حقوق الانسحاب محفوظة بموجب قانون حماية المستهلك رقم 6502.",
          ],
        },
        {
          id: "disclaimer",
          heading: "8. إخلاء المسؤولية وحدود المسؤولية",
          paragraphs: [
            "يتم توفير المنصة \"كما هي\". على الرغم من أن EntegrePanel تبذل جهودًا معقولة لضمان عمل المنصة دون انقطاع وبدون أخطاء، قد تحدث انقطاعات في الخدمة بسبب الظروف القاهرة أو مشاكل البنية التحتية للإنترنت أو انقطاعات خدمة الطرف الثالث أو الصيانة.",
            "لا يمكن تحميل EntegrePanel المسؤولية عن الأضرار غير المباشرة أو العرضية أو الخاصة أو العقابية (فقدان الربح، فقدان البيانات، انقطاع الأعمال، إلخ). تقتصر مسؤوليتنا الإجمالية على الرسوم التي دفعتها في آخر 12 شهرًا.",
          ],
        },
        {
          id: "termination",
          heading: "9. الإنهاء",
          paragraphs: [
            "تحتفظ EntegrePanel بالحق في تعليق أو إنهاء الحساب إذا انتهك المستخدم شروط الخدمة هذه أو قدم معلومات خاطئة أو أساء استخدام النظام أو شارك في أنشطة غير قانونية.",
          ],
        },
        {
          id: "changes",
          heading: "10. التغييرات في الشروط",
          paragraphs: [
            "قد تقوم EntegrePanel بتحديث شروط الخدمة هذه من وقت لآخر. يتم إخطار المستخدمين بالتغييرات الهامة عبر البريد الإلكتروني أو من خلال المنصة. الاستمرار في استخدام المنصة بعد نشر التغييرات يعني قبولك للشروط المحدثة.",
          ],
        },
        {
          id: "governing-law",
          heading: "11. القانون الحاكم والاختصاص",
          paragraphs: [
            "تخضع شروط الخدمة هذه للقانون التركي. محاكم بورصة ومكاتب الإنفاذ هي المختصة في حل النزاعات التي قد تنشأ من هذه الاتفاقية.",
          ],
        },
        {
          id: "contact",
          heading: "12. الاتصال",
          paragraphs: [
            "للأسئلة أو التعليقات حول شروط الخدمة، يمكنك الاتصال بنا: Hobala E-Ticaret Reklam Ve Aracılık LTD ŞTİ — Mesudiye Mah. Yıldırım Cad. Yokdemir İş Merkezi No:8، بورصة | الهاتف: +90 224 718 54 00 | البريد الإلكتروني: entegre@entegrepanel.net",
          ],
        },
      ],
    },
  },
};
